import React, {useEffect, useState} from 'react'
import '../App.css';
import '../css/body.css';
import { Outlet, Link } from "react-router-dom";
import { Col, Row,  } from 'antd';
import Spotify from '../components/frames/Spotify'
import Footer from '../components/Footer';
import certificaciones from '../assets/images/premioESR.webp'

import {  mazatlan, mochis } from '../assets/base64'
import pichilingue from '../assets/images/destinos/pichilingue.webp'

import videoRSE from '../assets/video/rse_sea.mp4'
import RSElogo from '../assets/images/LOGOS-RSE.png';
import RSEImg from '../assets/images/rseImg.webp'
import facebook from '../assets/images/spotify/facebook.svg';
import twitter from '../assets/images/spotify/twitter.svg';
import instagram from '../assets/images/spotify/instagram.svg';
import youtube from '../assets/images/spotify/youtube.svg';

import ruta from '../assets/images/ruta3.png'
import tarifa from '../assets/images/tarifas.svg'
import PromocionesHorizontal from '../components/PromocionesHorizontal';

import DestinosHorizontal from '../components/DestinosHorizontal';
import Valoracion from './Valoracion';
import { useTranslation } from 'react-i18next';
import cabostar from '../assets/images/promociones/swap/cabostar.webp'

import queNoPare from '../assets/images/promociones/queNoPare.webp'
import aniversario from '../assets/images/promociones/aniversario-23.webp'
import torton from '../assets/images/promociones/thorton.webp'
import ayudante from '../assets/images/promociones/ayudante.webp'

import ninos from '../assets/images/promociones/promo-ninos.png';
import bfpass from '../assets/images/promociones/bfpass.webp'
import adulto_mayor from '../assets/images/promociones/adulto-mayor.png';
import rodar from '../assets/images/promociones/biker2026.webp'
import promoCabo from '../assets/images/promociones/cabo/cabo.webp'
import NoticiaBody from '../components/NoticiaBody';
import bsgana from '../assets/images/promociones/bs/bsgana.webp'
import bsbf from '../assets/images/promociones/bs/bsbf.webp'

export default function BodyContent() {
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { t } = useTranslation('home');
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
        }, []);
        return (
        <>  
         
        <section className='itinerario-dic-ene'>
            <div className='container'>
                <div className='itinerario-dic-ene-container'>
                
                    <div className='itinerario-dic-ene-title'>
                        <h2>Itinerario actualizado</h2>                    
                    </div>
                    <div className='itinerario-dic-ene-background'>
                        <div className='itinerario-dic-ene-content'>                        
                            <button onClick={() => setOpen(!open)}>
                                <p>Hemos actualizado el itinerario. Te invitamos a revisar la versión más reciente.</p> 
                                {/*{open ? "Ocultar imagen" : "Ver nuevo itinerario"}*/}
                                {open ? <i className="fi fi-bs-angle-up"></i> : <i className="fi fi-bs-angle-down"></i>}
                            </button>

                            <div className={`slide-container ${open ? "open" : ""}`}>
                                <div className='itinerario-img-dic-ene'></div>
                            </div>
                        </div>
                    </div>   
                </div>                           

            </div>    
        </section> 
        
        <div class="d-none d-sm-none d-md-block">
            <section className="container" id='promociones'>            
                <div className='promociones_title_home '>
                    <h2>{t('text1')}</h2>
                    <p>{t('description1')}</p>                
                    <div className='promociones_title_home_cta'>                        
                        <Link  to="/promociones" class="learn-more">
                            <span class="circle" aria-hidden="true">
                            <span class="icon arrow"></span>
                            </span>
                            <span class="button-text">{t('btn1')} </span>
                        </Link>
                    </div>
                </div>

                <div className='promociones'> 
                    {/*
                    <div className='box_content_card_promo'>
                        <Link to="/bf-pass" aria-label="promocion bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${bfpass})` }}></div>
                        </Link>
                    </div> 
                                        
                    <div className='box_content_card_promo'>
                        <Link to="/promos-cabo-star" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${promoCabo})` }}></div>
                        </Link>
                    </div>

                    <div className='box_content_card_promo'>
                        <Link to="/promo-biker" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${rodar})` }}> </div>
                        </Link>
                    </div>
                  
                    <div className='box_content_card_promo'>
                        <Link to="/promo-tortonero" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${torton})` }}></div>
                        </Link>
                    </div>                                          
                                   
                    <div className='box_content_card_promo'>
                        <Link to="/promo-swap" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${cabostar})` }}> </div>
                        </Link>
                    </div> 
                    */}  
                   
                      <div className='box_content_card_promo'>
                        <Link to="/promo-ninos" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${ninos})` }}> </div>
                        </Link>
                    </div> 
                    <div className='box_content_card_promo'>
                        <Link to="/promo-adulto-mayor" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${adulto_mayor})` }}></div>
                    </Link>
                   </div>

                    {/*  
                    <div className='box_content_card_promo'>
                        <Link to="/promo-tortonero" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${promoNinos})` }}></div>
                        </Link>
                    </div>
                    <div className='box_content_card_promo'>
                        <Link to="/ayudante-operador" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${ayudante})` }}></div>
                        </Link>
                    </div>
                    <div className='box_content_card_promo'>
                        <Link to="/nacidos-para-rodar" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${rodar})` }}> </div>
                        </Link>
                    </div>
                    
                
                    <div className='box_content_card_promo'>
                        <Link to="/promo-adulto-mayor" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${adulto_mayor})` }}></div>
                        </Link>
                    </div>

                                                                                                                
                    <div className='box_content_card_promo'>
                        <Link to="/promo-adulto-mayor" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${adulto_mayor})` }}></div>
                        </Link>
                    </div>
                    <div className='box_content_card_promo'>
                        <Link to="/promo-ninos" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${ninos})` }}> </div>
                        </Link>
                    </div> 
                    <div className='box_content_card_promo'>
                        <Link to="/bf-pass" aria-label="promo bajaferries">
                            <div className='box_group_card_promo' style={{ backgroundImage: `url(${bfpass})` }}> </div>
                        </Link>
                    </div> 
                    */}
                    
                                                                                
                </div> 
            </section>
        </div>            
        
        <section class="d-block d-sm-block d-md-none">
            <div className="container" id='promociones'>                                
                <PromocionesHorizontal />                         
            </div>
        </section>

        {/* Rutas, Horarios y Tarifas */}
        <section className='cta_body'>
            <div className='container'>
                <div className='rutas_horario_text_box'>
                    <div className='rutas_horario_text'>
                        <h3>{t('description2')}</h3>
                        <p>{t('description3')}  <br />
                        {t('description4')}</p>
                    </div>
                </div>
            </div>
        </section>
        <section className='rutas_horario_body'>
            <div className='container'>
                <div className='cta_container_body'>
                    <div className='cta_box_body ruta-horario'>
                        <div className='cta_content_body'>
                            <div className='cta_img_body'><div className='cta_box_img_body'><img src={ruta}  alt='ruta y horarios'/></div></div>
                            <div className='cta_info_body'>                            
                                <div className='cta_text_body'>
                                    <h2>{t('text2')}</h2>
                                    <p>{t('text3')}</p>
                                </div>
                                <div className='cta_btn_body'>                                
                                    <Link to="/rutas_horario"> {t('btn1')}</Link>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className='cta_box_body tarifa'>
                        <div className='cta_content_body'>
                            <div className='cta_img_body'><div className='cta_box_img_body'><img src={tarifa} alt='tarifa baja ferries'/></div></div>
                            <div className='cta_info_body'>
                                <div className='cta_text_body'>
                                    <h2>{t('text4')}</h2>
                                    <p>{t('text5')}</p>
                                </div>                            
                                <div className='cta_btn_body'>
                                    <Link to="/tarifas"> {t('btn1')}</Link>
                                </div>
                            </div>
                        </div>                   
                    </div>                
                </div>
            </div>
        </section>
        
            
        {/*DESTINOS*/}
        <section className="d-none d-sm-none d-md-block">
            <div className='container'>
                <div className='container_destinos'>            
                    <div className='box_destinos'>
                        <h2>{t('text6')}</h2>
                        <p>{t('text7')}</p>
                    </div>
                    <Row>
                        <Col span={8}>
                            <div className='content_destino1'>
                                <Link to="/destino-la-paz"> <div className="cardDestinos">
                                        <img src={pichilingue} alt="pichilingue" className='imgDestino' />                        
                                        <div className="textDestino">
                                            <h4>La Paz, Baja California Sur.</h4> 
                                            <p>{t('text8')}</p> 
                                        </div>
                                    </div> 
                                </Link>                           
                            </div>
                        </Col>
                        <Col span={8}>
                            <div className='content_destino2'>
                            <Link to="/destino-mazatlan">
                                <div className="cardDestinos">
                                    <img src={mazatlan} alt="mazatlan" className='imgDestino' />                        
                                    <div className="textDestino">
                                        <h4>Mazatlán, Sinaloa.</h4> 
                                        <p>{t('text9')}</p> 
                                    </div>
                                </div>

                            </Link> 
                                
                            </div>
                        </Col>
                        <Col span={8}>
                            <div className='content_destino3'> 
                                <Link to="/destino-los-mochis">
                                    <div className="cardDestinos">
                                        <img src={mochis} alt="mochis" className='imgDestino' />                        
                                        <div className="textDestino">
                                            <h4>Los Mochis, Sinaloa.</h4> 
                                            <p>{t('text10')}</p> 
                                        </div>
                                    </div>
                                </Link> 
                                
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </section>
        <section className="d-block d-sm-block d-md-none">
            <section className="container" id='destinos'>                                
                <DestinosHorizontal />                         
            </section>
        </section>

        {/* <NoticiaBody />*/}

        {/*RSE*/}     
        <section className="d-none d-sm-none d-md-block">
            <div className='rse_section'>
                <div className='videoRSE'>                
                    {!isMobile && (
                    <video muted loop autoPlay={true} width="750" height="500" >
                        <source src={videoRSE} type="video/mp4" /> 
                    </video>
                    ) }
                        
                    <div className="content-text-rse">
                        <div className='container'>
                            <div className='container-text-rse'>
                                <img src={RSElogo} alt="RSElogo" className="RSElogo" />
                                <p>{t('text11')}</p>
                                <p>{t('text12')}</p>
                            </div>
                        </div>
                    </div>      
                </div>          
            </div>
        </section>
        <section className="d-block d-sm-block d-md-none">
            <div className='container'>
                <div className='RSEImg'>                
                    <img src={RSEImg} alt='baja ferries hero' />
                    <div className='content-text-rse-mobile'>
                        <img src={RSElogo} alt="RSElogo" className="RSElogo" />
                        <p>{t('text11')}</p>
                        <p>{t('text12')}</p>
                    </div>
                </div>
            </div> 
        </section>

       
        {/* SPOTIFY */}
        <section className='spotify_section'>            
            <div className='container'>
                <div className='box_spotify'>                                                                                   
                    <div className='list_icon_spotify'>
                        <div className='title_spotify'>
                            <h3>{t('text15')}</h3>
                        </div>
                        <ul>
                            <li>
                                <a href="https://www.facebook.com/bajaferriesoficial/" rel='noopener noreferrer' target="_blank"><img src={facebook} alt='facebook oficial bajaferries' className='bg_spotify' /> </a>                                                                            
                            </li>
                            <li>                                        
                                <a href="https://x.com/bajaferries" rel='noopener noreferrer' target="_blank"><img src={twitter} alt='twitter oficial bajaferries' className='bg_spotify' /> </a>                                      
                            </li>
                            <li>
                                <a href="https://www.instagram.com/bajaferriesoficial/" rel='noopener noreferrer' target="_blank"><img src={instagram} alt='instagram oficial bajaferries' className='bg_spotify' /> </a>                                                                                
                            </li>
                            <li>
                                <a href="https://www.youtube.com/@bajaferries2914" rel='noopener noreferrer' target="_blank"><img src={youtube} alt='youtube oficial bajaferries' className='bg_spotify' /></a>                                                                                
                            </li>
                            
                        </ul>
                    </div>                
                    <div className='content_frame_spotify'>
                        <div className='frame_spotify'>
                            <Spotify />
                        </div>
                    </div>
                </div>
            </div>
        </section>


        {/*CERTIFICACIONES
        <section>
            <div className='container'>
                <Carousel logos={logos} />
            </div>
        </section>
        */}
    <section>
        <div className='container'>
            <div className='certificaciones_body'>
                <div className='certificaciones_box_body'>
                    <img src={certificaciones} alt='cerfificaciones de baja ferries' />
                </div>
                <div className='certificaciones_box_body text_certificaciones'>
                    <h2>{t('text16')}</h2>
                    <p>
                        {/*Las certificaciones que hemos obtenido son el resultado de nuestro compromiso continuo con la excelencia, son un sello de aprobación que demuestra que cumplimos con los estándares más rigurosos en nuestra industria. Queremos que te sientas seguro al utilizar nuestros servicios.*/}
                        {t('text17')} 
                    </p>
                    <div className='btn_certificaciones_box'>
                        
                        <Link  to="/certificaciones" class="learn-more">
                            <span class="circle" aria-hidden="true">
                            <span class="icon arrow"></span>
                            </span>
                            <span class="button-text"> {t('btn2')}</span>
                        </Link>                        
                    </div>
                </div>
            </div>
            
        </div>
    </section>

    {/*FOTER*/}
    <Footer />

    <Valoracion />

    <Outlet />
    </>
  )
}
